export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_UP_SUCCESS = '/signupsuccess';
export const SIGN_IN = '/signin';
export const HOME = '/home';
export const EXHIBIT = '/exhibit';
export const MUSIC = '/music';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const ADMIN_DETAILS = '/admin/:id';
export const PASSWORD_FORGET = '/pw-forget';
